@use './nav-list-items.vars.scss' as *;

:host {
  .fds-nav-list-items {
    margin: 0;
    padding: 0;
    list-style: none;
  }
}
